import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { motion } from 'framer-motion';
import { useAdmin } from '../lib/AdminContext';
import { useNavigate } from 'react-router-dom';

export default function Admin() {
  const { session, isAdmin, isLoading: isContextLoading } = useAdmin();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
      navigate('/');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  if (isContextLoading) {
    return <div className="min-h-[60vh] flex items-center justify-center">Loading...</div>;
  }

  if (!isAdmin) {
    return (
      <div className="max-w-md mx-auto mt-24 bg-white dark:bg-brand-slate p-8 rounded-2xl shadow-lg border border-sand-100">
        <h2 className="text-2xl font-bold mb-6 text-[#333] dark:text-[#fff] text-center">Admin Login</h2>
        {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1 text-[#333] dark:text-[#fff]">Email</label>
            <input
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 border border-sand-200 rounded-lg bg-sand-50 dark:bg-brand-slate/80 focus:ring-2 focus:ring-brand-rose outline-none text-[#333] dark:text-[#fff]"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 text-[#333] dark:text-[#fff]">Password</label>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border border-sand-200 rounded-lg bg-sand-50 dark:bg-brand-slate/80 focus:ring-2 focus:ring-brand-rose outline-none text-[#333] dark:text-[#fff]"
              required
            />
          </div>
          <button type="submit" disabled={isLoading} className="w-full px-8 py-3 bg-brand-rose text-white dark:text-white rounded-full font-medium hover:brightness-110 shadow-[2px_2px_0px_0px_rgba(45,55,72,1)] border-2 border-brand-darkGray disabled:opacity-50">
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-4xl mx-auto px-4 py-24 text-center">
      <div className="bg-white dark:bg-brand-slate p-8 rounded-2xl shadow-lg border border-sand-100 max-w-md mx-auto">
        <h1 className="text-3xl font-bold text-[#333] dark:text-[#fff] mb-6">Welcome, Admin!</h1>
        <p className="text-[#333] dark:text-[#fff] mb-8">
          You can now edit content directly on the site pages.
        </p>
        <div className="space-y-4">
          <button
            onClick={() => navigate('/')}
            className="w-full px-6 py-3 bg-brand-rose text-white dark:text-white rounded-full font-medium hover:brightness-110 transition-all shadow-[2px_2px_0px_0px_rgba(45,55,72,1)] border-2 border-brand-darkGray hover:translate-y-1 hover:shadow-none"
          >
            Go to Home
          </button>
          <button
            onClick={handleLogout}
            className="w-full px-6 py-3 bg-sand-200 hover:bg-sand-300 dark:bg-brand-slate dark:hover:bg-brand-slate/80 text-[#333] dark:text-[#fff] rounded-full font-medium transition-colors border border-sand-300"
          >
            Logout
          </button>
        </div>
      </div>
    </motion.div>
  );
}
